export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'ru-jia-lun-li',
    name: '儒家伦理与韩国',
    description: '深入探讨儒家思想对韩国社会伦理体系的深远影响，从历史渊源到当代实践，全面解析儒家伦理在韩国的传承与演变。',
    icon: 'ri-book-open-line',
    articleCount: 4,
  },
  {
    slug: 'xian-dai-she-hui-dao-de',
    name: '现代社会道德',
    description: '聚焦当代韩国社会道德观念的演变趋势，分析全球化与信息化背景下韩国人道德价值观的变迁与挑战。',
    icon: 'ri-global-line',
    articleCount: 4,
  },
  {
    slug: 'zhi-chang-lun-li',
    name: '职场伦理规范',
    description: '系统介绍韩国独特的职场伦理文化，包括等级制度、团队精神、敬业态度等核心要素及其在现代企业中的体现。',
    icon: 'ri-briefcase-line',
    articleCount: 3,
  },
  {
    slug: 'jia-ting-lun-li',
    name: '家庭伦理文化',
    description: '深度解析韩国家庭伦理的传统根基与现代变革，探讨孝道、婚姻观念、代际关系等家庭伦理核心议题。',
    icon: 'ri-home-heart-line',
    articleCount: 4,
  },
  {
    slug: 'chuan-tong-jia-zhi-guan',
    name: '韩国传统价值观',
    description: '追溯韩国传统价值观的历史脉络，解读礼仪、忠诚、和谐等核心价值观在韩国文化中的体现与当代意义。',
    icon: 'ri-landscape-line',
    articleCount: 3,
  },
];